import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CmpsCardComponentModule } from '@cmps/ng-kit';
import { CmpsIconModule } from '@cmps/ng-uikit';

import { CmpsMyCoachingCardModule } from '../card--my-coaching-card/my-coaching-card.module';
import { CmpsMyPerformanceCardModule } from '../card--my-performance-card/my-performance-card.module';
import { CmpsMyScorecardModule } from '../card--my-scorecard/my-scorecard.module';
import { CmpsCoachingCardRepModule } from '../card-coaching-card-rep/coaching-card-rep.module';
import { CmpsCommonModule } from '../common/common.module';
import { CmpsLazyRouterModule } from '../route.module';

import { InsightNewComponent } from './insight-new.component';
import { InsightRoutes } from './insight-new.route';

@NgModule({
    imports: [
        CommonModule,
        CmpsCommonModule,
        CmpsIconModule,
        CmpsLazyRouterModule.forChild(InsightRoutes),
        CmpsCardComponentModule,
        CmpsMyCoachingCardModule,
        CmpsCoachingCardRepModule,
        CmpsMyScorecardModule,
        CmpsMyPerformanceCardModule,
    ],
    declarations: [InsightNewComponent],
    exports: [InsightNewComponent],
})
export class CmpsInsightNewModule {}
